<template>

    <!-- EDIT MODE -->
    <div v-if="editMode" class="text-left">

        <project-info-box :sub-panel-translations="subPanelTranslations"
                          :visible="true"
                          :componentData="componentData"
                          :editable="true"
                          :settings="settings"
                          @change="subPanelTranslationsChanged"
        ></project-info-box>

        <text-editor
            v-model="actionButtonTextModel"
            hint="Start project button text">

            <ninja-button
                :settings="settings"
                class="mt-5"
            >
                {{ subPanelTranslations.start_project_button_text }}
            </ninja-button>

        </text-editor>

    </div>

    <!-- RENDER MODE -->
    <div v-else class="text-left">

        <project-info-box :sub-panel-translations="subPanelTranslations"
                          :visible="true"
                          :componentData="componentData"
                          :editable="false"
                          :display-edit-info="displayEditInfo"
                          :settings="settings"
        ></project-info-box>

        <v-tooltip top color="primary" :disabled="!displayEditInfo" :open-delay="500">
            <template v-slot:activator="{ on }">

                <ninja-button
                    @click="startProject"
                    v-on="on"
                    class="mt-5"
                    :loading="loading"
                    :settings="settings"
                >
                    {{ subPanelTranslations.start_project_button_text }}
                </ninja-button>
            </template>
            Button text can be edited in the Sub Panel Landing Page Templates
        </v-tooltip>

    </div>

</template>

<script>

import TextEditor from "@/components/UI/TextEditor.vue";
import ProjectInfoBox from "@/components/UI/LandingPage/ProjectInfoBox.vue";
import NinjaButton from "@/components/UI/NinjaButton.vue";

export default {

    components: {
        NinjaButton,
        TextEditor,
        ProjectInfoBox
    },

    props: {
        editMode: {
            type: Boolean,
            required: false,
            default: false,
        },
        subPanelTranslations: {
            type: Object,
            required: true,
            default: false
        },
        settings: {
            type: Object,
            required: false,
            default: null,
        },
        componentData: {
            type: Object,
            required: false,
            default: () => {
                return {
                    surveyUrl: null,
                    reward_completed: null,
                    loi: null,
                    mobile_friendly: null,
                    tablet_friendly: null,
                    desktop_friendly: null,
                }
            }
        },
        displayEditInfo: {
            type: Boolean,
            required: false,
            default: false,
        }
    },

    data() {
        return {
            loading: false,
        }
    },

    computed: {
        actionButtonTextModel: {
            get() {
                return this.subPanelTranslations.start_project_button_text;
            },
            set(value) {
                this.$emit('change:subPanelTranslations', {start_project_button_text: value});
            }
        },
    },

    methods: {
        startProject() {
            if (!this.displayEditInfo) {
                this.loading = true;
                window.location = this.componentData.surveyUrl;
            }
        },

        subPanelTranslationsChanged(translations) {
            this.$emit('change:subPanelTranslations', translations);
        }
    }
}
</script>
